import store from '../store/store';
import SetSweepRuleOperation from 'owa-service/lib/contract/SetSweepRuleOperation';
import { action } from 'satcheljs/lib/legacy';

export default action('setSweepRuleUIUpdate')(function setSweepRuleUIUpdate(
    sweepRuleId: string,
    sweepOperation: SetSweepRuleOperation
) {
    let sweepRule = store.sweepRules.get(sweepRuleId);

    switch (sweepOperation) {
        case SetSweepRuleOperation.Enable:
            sweepRule.IsEnabled = true;
            break;
        case SetSweepRuleOperation.Disable:
            sweepRule.IsEnabled = false;
            break;
        case SetSweepRuleOperation.Delete:
            store.sweepRules.delete(sweepRuleId);
            store.sweepRuleIds.splice(store.sweepRuleIds.indexOf(sweepRuleId), 1);
            break;
        default:
            throw new Error('Could not find SetSweepRuleOperation');
    }
});
